import { AlignmentToolbar, BlockControls } from '@wordpress/block-editor';
import { Toolbar, ToolbarButton, ToolbarDropdownMenu, ToolbarGroup } from '@wordpress/components';
import { DropdownOption } from '@wordpress/components/build-types/dropdown-menu/types';
import { __ } from '@wordpress/i18n';
import {
  heading,
  headingLevel1,
  headingLevel2,
  headingLevel3,
  headingLevel4,
  headingLevel5,
  headingLevel6,
} from '@wordpress/icons';
import React from 'react';

interface ControlsProps {
  attributes: {
    kicker?: string;
    headline?: string;
    headlineLevel?: number;
    textAlign?: string;
  };
  setAttributes: (attributes: Record<string, any>) => void;
}



const Controls: React.FC<ControlsProps> = ({ attributes: { headlineLevel, textAlign }, setAttributes }) => {
  const icon = () => {
  if ( headlineLevel === 1) {
    return headingLevel1;
  } else if ( headlineLevel === 2) {
    return headingLevel2;
  } else if ( headlineLevel === 3) {
    return headingLevel3;
  } else if ( headlineLevel === 4) {
    return headingLevel4;
  } else if ( headlineLevel === 5) {
    return headingLevel5;
  } else if ( headlineLevel === 6) {
    return headingLevel6;
  } else {
    return heading;
  }
}

  const headlineSelect: DropdownOption[] = [
    {
      title: 'Überschrift 1',
      icon: headingLevel1,
      onClick: () => setAttributes({ headlineLevel: 1 }),
      isActive: headlineLevel === 1,
    },
    {
      title: 'Überschrift 2',
      icon: headingLevel2,
      onClick: () => setAttributes({ headlineLevel: 2 }),
      isActive: headlineLevel === 2,
    },
    {
      title: 'Überschrift 3',
      icon: headingLevel3,
      onClick: () => setAttributes({ headlineLevel: 3 }),
      isActive: headlineLevel === 3,
    },
    {
      title: 'Überschrift 4',
      icon: headingLevel4,
      onClick: () => setAttributes({ headlineLevel: 4 }),
      isActive: headlineLevel === 4,
    },
    {
      title: 'Überschrift 5',
      icon: headingLevel5,
      onClick: () => setAttributes({ headlineLevel: 5 }),
      isActive: headlineLevel === 5,
    },
    {
      title: 'Überschrift 6',
      icon: headingLevel6,
      onClick: () => setAttributes({ headlineLevel: 6 }),
      isActive: headlineLevel === 6,
    },
  ];

  return (
    <BlockControls>
      <ToolbarGroup>
        <ToolbarDropdownMenu icon={icon()} label="Select a headline" controls={headlineSelect} />
      </ToolbarGroup>
      <AlignmentToolbar value={textAlign} onChange={(newAlign) => setAttributes({ textAlign: newAlign })} />
    </BlockControls>
  );
};

export default Controls;
